import axios from 'axios';

export const instanceMsCalc = axios.create({
    baseURL: process.env.REACT_APP_MS_CALC_URL ?? 'http://localhost:5001',
    headers: { Authorization: process.env.REACT_APP_AUTH_TOKEN ?? '' },
});